import transactionSession from '../instance';

const dedicateTransactionSession = (contextType) => {
  transactionSession.open(contextType, true);
};

export default dedicateTransactionSession;
